import { Injectable } from '@angular/core'
import { ContextService } from './context.service'
import { HttpClient } from '@angular/common/http'
import { AuthenticationService } from './auth.service'
import { ITerritory, User } from '../models/User'

@Injectable()
export class UserService {
  get username() {
    return this.auth.data?.user?.username || ''
  }

  get apiKey() {
    return this.auth.data?.user?.api_key || ''
  }

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService,
    private context: ContextService,
  ) {}

  getUser(user: string) {
    return Promise.resolve({})
  }

  getUsers(): Promise<any> {
    return Promise.resolve([])
  }

  createUser(user: User) {
    return Promise.resolve({})
  }

  editUser(username: string, user: User) {
    return Promise.resolve({})
  }

  deleteUser(user: User) {
    return Promise.resolve({})
  }

  getTerritories(): Promise<ITerritory[]> {
    return Promise.resolve([])
  }
}
